import { ActionTypes } from '../account/constants'

const initialState = {
    email: '',
    approve: false,
};

const AccountReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_ACC:
            return payload
        default:
            return state;
    }
}

export default AccountReducer;